module.exports = __webpack_public_path__ + "static/media/send_message_disabled.8c670bf9.svg";